import { Component, OnInit } from '@angular/core';
import { IpService } from '../_service/ip.service';
import { IspService } from '../_service/isp.service';
import { StoreService } from '../_service/store.service';
import { HelperService } from '../_service/helper.service';

import { APIService } from '../_service/api.service';
import { AlertService } from '../_service/alert.service';

import { ChangePassword } from '../_model/changepassword';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { matchOtherValidator } from '../_validator/match-other-validator';
import { PasswordValidator } from '../_validator/password-validator';
// import { } from '@types/googlemaps';
// import 'googlemaps'

@Component({
    selector: 'settings',
    templateUrl: 'settings.component.html',
    styleUrls: ['settings.component.css'],
})
export class SettingsComponent implements OnInit {
    didLoad: boolean;
    currentUser: any;

    rows: any[] = [];
    selectedRows: any[] = [];
    reorderable = true;

    latitude: any;
    longitude: any;
    zoom = 11;

    ispName: string;
    ipv4: string;
    ipv6: string;

    model: any = {};

    didLoadSessions = false;

    form: FormGroup;

    loading = false;

    public changePassword: ChangePassword;

    constructor(private api: APIService,
                private ipService: IpService,
                private ispService: IspService,
                private storeService: StoreService,
                private helperService: HelperService,
                private fb: FormBuilder,
                private alertService: AlertService) {
        this.form = fb.group({
            oldPassword: [null, [Validators.required, Validators.minLength(4)]],
            newPassword: [null, [Validators.required, PasswordValidator.strongPassword()]],
            newPasswordConfirm: [null, [
                Validators.required,
                matchOtherValidator('newPassword'),
            ]],
        });
    }

    onSubmit() {
        if (this.currentUser) {
            this.loading = true;
            const changePassword: ChangePassword = {
                oldPassword: this.form.value['oldPassword'],
                newPassword: this.form.value['newPassword'],
                newPasswordConfirm: this.form.value['newPasswordConfirm'],
            };
            const token: string = this.currentUser.token;
            this.api.updatePassword(token, changePassword)
                .subscribe(
                    data => {
                        this.loading = false;
                        if (data && data['error']) {
                            // Handle password complexity error from API
                            this.alertService.error(data['details'] ? data['details'].join(', ') : data['error']);
                        } else {
                            this.alertService.success('Password changed successfully');
                            this.form.reset();
                        }
                    },
                    error => {
                        this.loading = false;
                        // Check for specific error messages from API
                        if (error && error.error && error.error.message) {
                            this.alertService.error(error.error.message);
                        } else if (error && error.status === 401) {
                            this.alertService.error('Current password is incorrect');
                        } else {
                            this.alertService.error('Failed to change password. Please try again.');
                        }
                        // Don't reset form on error so user can correct it
                    });
        }

    }

    ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        // this.loadSessions();

        if (!this.storeService.isp.latitude || !this.storeService.isp.longitude) {
            this.ispService.getIsp()
                .subscribe(
                    data => {
                        this.helperService.processIsp(data);
                        this.setMap();
                        this.setIps();
                        this.didLoad = true;
                    },
                    error => {
                        // console.log("error: ", error);
                    });
        } else {
            this.setIps();
            this.setMap();
        }
        if (!this.storeService.test.ip || !this.storeService.test.ipv6) {
            this.ipService.getIp()
                .subscribe(
                    data => {
                        if (data.type == 'IPv6') {
                            const ipv6 = data.ip;
                            this.ipv6 = ipv6;
                            this.storeService.test.ipv6 = ipv6;
                        }
                        this.setIps();
                    },
                    error => {
                        // console.log("error: ", error);
                    });
        } else {
            this.setIps();
        }

        this.changePassword = {
            oldPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
        };
    }

    // updatePassword(model: ChangePassword, isValid: boolean) {
    // 	console.log(model, isValid);
    // }

    updatePassword(val: any) {
        // console.log(val)
    }

    setMap() {
        this.didLoad = true;
        this.latitude = this.storeService.isp.latitude;
        this.longitude = this.storeService.isp.longitude;

    }

    setIps() {
        this.ispName = this.storeService.ispName;
        this.ipv4 = this.storeService.test.ip;
        this.ipv6 = this.storeService.test.ipv6;
    }

    loadSessions() {
        if (this.currentUser) {
            const token: string = this.currentUser.token;
            this.api.getSessions(token)
                .subscribe(
                    data => {
                        this.presentData(data.reverse());
                        this.didLoadSessions = true;
                    },
                    error => {
                        // console.log(error)
                    });
        }
    }

    presentData(data: any[]) {
        this.rows = data;
    }

    delete(row: any) {
        // console.log(row)
        // If logged in delete from database
        if (this.currentUser) {
            const token: string = this.currentUser.token;
            this.api.deleteSession(token)
                .subscribe(
                    data => {
                        console.log();
                    },
                    error => {
                        console.log();
                    });
        }
    }
}
